let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Di5o")).then(() => parcelRequire('eYlAr'));